// extracted by css-extract-rspack-plugin
export default {"root":"WDM0Ae3GoWeJmzw2"};